import { Box } from "@mui/material";
import styled from "styled-components";

export const VisitTimeStyled = styled(Box)`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  .slots-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    max-height: 374px;
    overflow-y: auto;
    padding: 6px;

    .sub-text {
      align-self: center;
    }
    .desp {
      font-size: 14px;
      line-height: 21px;
    }
    .time-slots {
      display: flex;
      flex-direction: column;
      row-gap: 16px;
    }
  }
  .lightbtn-wrapper {
    width: 100%;
  }
`;
